export const CURRENCIES = ["€", "$", "₺", "RM"];

export const STATUSES = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};

export const ACCOUNT_STATUSES = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

export const LOG_CATEGORY_TYPES = ["Chargeable", "Non-Chargeable", "Both"];

export const INPUT_ERRORS = {
  REQUIRED: (key: string) => `${key} is required`,
  INVALID_TYPE: (key: string, type: string) => `${key} must be a ${type}`,
  MIN_LENGTH: (key: string, length: number) =>
    `${key} must be at least ${length} characters`,
  MAX_LENGTH: (key: string, length: number) =>
    `${key} must be at most ${length} characters`,
  INVALID_LENGTH: (key: string, length: number) =>
    `${key} must be exactly ${length} characters`,
};


export const RESOURCE_SERVICE_LEVELS = [
  "Level 1",
  "Level 2",
  "Level 3",
  "Level 4",
];

export const SOW_PACKAGE_NAMES = [
  "Conversion Rate Optimization"
];
